import { useEffect, useState } from "react";
import { Navigate, useNavigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';

import { useLocalStorage } from './../hooks/useLocalStorage';
import { getEstadoAccesoCredenciales } from "../components/services/LoginService";


export function RequireAuthAccesoCredenciales({ children }) {
  const navigate = useNavigate();
  // const { credActivo } = useAuthentication();
  // 
  const [credActivo,setCredActivo]=useState();
  

  useEffect(() => {
    getEstadoAccesoCredenciales().then((data) => {
        // true → hay acceso (permitido), false → no hay acceso
        setCredActivo(data) 
        
        
      }).catch((err) => {
        // console.error("Error obteniendo estado de acceso:", err);
        // Por precaución, bloqueamos si hay error
        setCredActivo(false);
      });
  },[])

  useEffect(() => {
    if (credActivo === false) {
      navigate("/", { replace: true });
    }
  }, [navigate, credActivo]);
  if (credActivo === null) return <div>Cargando...</div>; // Mostrar carga mientras se verifica
  return credActivo ? children : null; // Renderizar hijos si hay acceso
}

/**
 * Controla si existe authenticación para navegar o redirigir al login
 *
 * @param {String} children
 * @returns redirige a la ruta pública
 */
export function RequireAuth({ children }) {
  const [user] = useLocalStorage('user', '')
  const [authed] = useAuth(user)
  

  //return children

  return authed === true ? children : <Navigate to='/login' replace />
}

/**
 * Controla si existe authenticación Admin o Autorizador para navegar o redigir al login
 *
 * @param {String} children
 * @returns redirige a la ruta privada
 */
export function RequireAuthAdmin({ children }) {
  const [user] = useLocalStorage('user', '')
  const [authed] = useAuth(user)
  return authed === true && user.roles.includes('ROLE_ADMIN') ? (
    children
  ) : (
    <Navigate to='/login' replace />
  )
}

/**
 * Controla si existe authenticación Admin o Autorizador para navegar o redigir al login
 *
 * @param {String} children
 * @returns redirige a la ruta privada
 */
export function RequireAuthAdminAutorizador({ children }) {
  const [user] = useLocalStorage('user', '')
  const [authed] = useAuth(user)
  return authed === true &&
    (user.roles.includes('ROLE_ADMIN') ||
      user.roles.includes('ROLE_AUTORIZADOR') ||
      user.roles.includes('ROLE_JUSTIFICADOR')) ? (
    children
  ) : (
    <Navigate to='/login' replace />
  )
}


export function RequireAuthTieneA1({ children }) {
  const [user] = useLocalStorage('user', '')
  const [authed] = useAuth(user)
  const [dataAdquisicion] = useState(
    JSON.parse(localStorage.getItem("dataAdquisicion"))
  );

  return authed === true &&
    (user.roles.includes('ROLE_ADMIN') ||
      user.roles.includes('ROLE_AUTORIZADOR') ||
      user.roles.includes('ROLE_JUSTIFICADOR')) && dataAdquisicion.a1 ? (
    children
  ) : (
    <Navigate to='/adquisicion' replace />
  )
}


export function RequireAuthTieneA2({ children }) {
  const [user] = useLocalStorage('user', '')
  const [authed] = useAuth(user)
  const [dataAdquisicion] = useState(
    JSON.parse(localStorage.getItem("dataAdquisicion"))
  );

  return authed === true &&
    (user.roles.includes('ROLE_ADMIN') ||
      user.roles.includes('ROLE_AUTORIZADOR') ||
      user.roles.includes('ROLE_JUSTIFICADOR')) && dataAdquisicion.a2 ? (
    children
  ) : (
    <Navigate to='/adquisicion' replace />
  )
}